import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import { exitFullScreen } from '@galo-monitor/icons'
import { colors } from '@galo-monitor/styles'
import Icon from '@galo-monitor/web-components/Icon'

import IconButton from '../IconButton'

const ExitFullScreenIconButton = ({ iconColor, ...props }) => {
  const t = useT()
  return (
    <IconButton tooltip={ t('exit full screen') } { ...props }>
      <Icon icon={ exitFullScreen } color={ iconColor } />
    </IconButton>
  )
}

ExitFullScreenIconButton.propTypes = {
  iconColor: PropTypes.string
}

ExitFullScreenIconButton.defaultProps = {
  iconColor: colors.mutedText
}

export default ExitFullScreenIconButton
